import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';
import { FormButton } from 'theme/elements/Buttons';
import { CenteredNarrowContent } from 'theme/elements/Content';
import { HeaderPage4 } from 'theme/elements/Headers';

export default function SuccessfulInquireMessage(props: {
	handleOnClick: any;
	title: string;
	subtitle: string;
	buttonText: string;
	imageKey: string;
}) {
	const t = useAppSelector(selectTranslations);
	const imageUrl = useAppSelector(selectImageUrl);

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: '50px' }}>
			<CenteredNarrowContent>
				<Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
					<img src={imageUrl(props.imageKey) || '/static_images/brand-image-4.png'} height="172" alt="" />
				</Box>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						textAlign: 'center',
						maxWidth: '420px',
						margin: 'auto',
					}}
				>
					<HeaderPage4 title={props.title} />
					<Typography>{props.subtitle}</Typography>
				</Box>
				<FormButton sx={{ marginTop: '72px' }}>
					<Button sx={{ width: '100%' }} variant="outlined" onClick={props.handleOnClick}>
						{props.buttonText}
					</Button>
				</FormButton>
			</CenteredNarrowContent>
		</Box>
	);
}
